function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rocket",
    d: "M17.88,7.54c-0.39,0.39-1.03,0.39-1.42,0s-0.39-1.03,0-1.42s1.03-0.39,1.42,0S18.27,7.15,17.88,7.54z   M20.5,3.84c0-0.09-0.04-0.17-0.1-0.23c-0.07-0.07-0.16-0.1-0.25-0.1c-1.53-0.05-3.06,0.2-4.49,0.74c-1.4,0.65-2.67,1.56-3.73,2.69  c-0.55,0.56-1.16,1.23-1.83,2L6.15,9.15C6.04,9.16,5.94,9.22,5.88,9.32l-2.33,4c-0.09,0.13-0.06,0.3,0.05,0.41l0.67,0.67  c0.06,0.06,0.15,0.09,0.24,0.09H4.6l2.87-0.88l2.93,2.93L9.52,19.4c-0.04,0.12-0.01,0.24,0.08,0.33l0.67,0.67  c0.07,0.06,0.15,0.09,0.24,0.09c0.06,0.01,0.11,0.01,0.17,0l4-2.33c0.09-0.06,0.16-0.16,0.17-0.27L15,13.91  c0.79-0.67,1.46-1.28,2-1.83c1.11-1.07,2.01-2.34,2.64-3.75c0.56-1.43,0.82-2.95,0.79-4.48l0,0L20.5,3.84z",
    style: {
      fill: "rgb(84, 88, 90)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.ced52946.svg";
export { ForwardRef as ReactComponent };